export const internationalIcon = '/assets/sport/icons/international.svg';
export const couponToastContainerId = 'coupon-toast-container';
export const betsToastContainerId = 'bets-toast-container';
export const historyToastContainerId = 'history-toast-container';

// Атрибут для отработки клика по элементам линии
export const lineRowLinkDataAttributes = {
  'data-line-row-link': true,
};
